import { Select as AntSelect, SelectProps } from 'antd';
import styled, { css } from 'styled-components';

interface ICusSelect extends SelectProps {
  active?: boolean;
}

export const CusSelect = styled(AntSelect)<ICusSelect>`
  &&.emp-ant-select {
    width: 150px;
    color: rgba(0, 0, 0, 0.85);

    .emp-ant-select-selector {
      width: 100%;
      height: 28px;
      border-radius: 3px;
      border: solid 1px transparent;
      background-color: transparent;

      ${(props) => {
        if (props.active) {
          return css`
            background-color: #e6edff;
            border: solid 1px rgba(0, 0, 0, 0.15);
            color: #0046ff;
          `;
        }
      }}
      &:hover {
        border: solid 1px rgba(0, 0, 0, 0.15);
      }

      .emp-ant-select-selection-item {
        font-weight: 500;
        letter-spacing: -0.01em;
        line-height: 26px;
      }
    }

    .emp-ant-select-clear {
      background: transparent !important;
    }

    .emp-ant-select-selection-placeholder {
      color: rgba(0, 0, 0, 0.45);
      font-weight: 400;
    }
  }

  &&.emp-ant-select-disabled.emp-ant-select:not(.emp-ant-select-customize-input)
    .emp-ant-select-selector {
    color: rgba(0, 0, 0, 0.88);
  }
`;
